import { AppApiGateway } from '@repo/api/web/AppApiGateway'
import type {
  CartPricingLineRequest,
  CartPricingRequest,
  CartPricingResponse,
} from '@repo/api/web/models'
import {
  CartPricingRequest as CartPricingRequestModel,
  SetPromoCodeRequest,
} from '@repo/api/web/models'
import { inject, injectable } from 'inversify'

@injectable()
export class PromotionService {
  protected appConfig = useAppConfig()

  constructor(
    @inject(AppApiGateway)
    readonly api: AppApiGateway,
  ) {}

  pricing(
    lines: CartPricingLineRequest[] | null,
    pointsToSpend = 0,
  ): Promise<CartPricingResponse> {
    const model = CartPricingRequestModel.createLazy({
      lines: lines ?? undefined,
      pointsToSpend,
    } as CartPricingRequest)

    return this.api.cartsPricing(this.appConfig.host, model)
  }

  setPromoCode(code: string): Promise<void> {
    return this.api.cartsSetPromoCode(
      this.appConfig.host,
      SetPromoCodeRequest.createLazy({ code }),
    )
  }

  clearPromoCode(): Promise<void> {
    return this.api.cartsClearPromoCode(this.appConfig.host)
  }
}
